// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webinar {
  min-height: calc(100vh - ((100rem + 57rem)*1.3));
  max-height: max-content;
}
.sber-desc {
  display: 'flex';
  align-items: 'center';
  justify-content: 'flex-start';
}
`, "",{"version":3,"sources":["webpack://./src/pages/WebinarsPage/ui/WebinarPage.style.less"],"names":[],"mappings":"AAAA;EACI,gDAAA;EACA,uBAAA;AACJ;AAEA;EACI,eAAA;EACA,qBAAA;EACA,6BAAA;AAAJ","sourcesContent":[".webinar {\n    min-height: calc(100vh - ((100rem + 57rem)*1.3));\n    max-height: max-content;\n}\n\n.sber-desc {\n    display: 'flex';\n    align-items: 'center';\n    justify-content: 'flex-start';\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
